import React from "react";
import { useNavigate } from "react-router-dom";
import { useUserAuth } from "../context/userAuthContext";
import { Shield, AlertTriangle, Home, ArrowLeft } from "lucide-react";

const NotAuthorizedScreen = () => {
  const navigate = useNavigate();
  const { user } = useUserAuth();

  const goBack = () => {
    navigate(-1);
  };

  const goHome = () => {
    navigate("/dashboard");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-8 border border-slate-200 text-center">
        <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <AlertTriangle className="w-10 h-10 text-red-600" />
        </div>
        
        <h1 className="text-2xl font-bold text-slate-900 mb-3">
          Acceso No Autorizado
        </h1>
        
        <p className="text-slate-600 mb-6">
          No tienes permisos para acceder a este recurso.
        </p>

        {user && (
          <div className="bg-slate-50 rounded-lg p-4 mb-6 text-left">
            <p className="text-sm text-slate-600 mb-1">
              <strong>Usuario:</strong> {user.email}
            </p>
            <p className="text-sm text-slate-600">
              <strong>Rol actual:</strong>{" "}
              <span className="font-semibold text-slate-900">
                {user.type || "usuario"}
              </span>
            </p>
            {user.type !== "admin" && (
              <p className="text-xs text-slate-500 mt-2">
                Necesitas ser administrador para acceder a esta sección.
              </p>
            )}
          </div>
        )}

        <div className="flex flex-col sm:flex-row gap-3">
          <button
            onClick={goBack}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-3 border-2 border-slate-300 rounded-xl font-semibold text-slate-700 hover:bg-slate-50 transition-all"
          >
            <ArrowLeft className="w-4 h-4" />
            Regresar
          </button>
          <button
            onClick={goHome}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-3 bg-gradient-to-r from-[#218e01] to-[#5fc500] rounded-xl font-semibold text-white hover:shadow-lg transition-all"
          >
            <Home className="w-4 h-4" />
            Ir al Dashboard
          </button>
        </div>

        {user && user.type !== "admin" && (
          <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-xl">
            <p className="text-xs text-blue-800">
              💡 Si necesitas acceso de administrador, contacta con el equipo de soporte.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default NotAuthorizedScreen;
